export const typography = {
  fontFamily: '"DM Sans", sans-serif',
  h3: {
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: 500,
    fontSize: '2.125rem',
    lineHeight: 1.29,
    letterSpacing: '-0.015625em',
  },
  h5: {
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: 500,
    fontSize: '1.725rem',
    lineHeight: 1.29,
    letterSpacing: '-0.025625em',
  },
};
